// src/stores/useRouteStore.js
import { create } from 'zustand'
// Импортируйте ровно тот же экземпляр, что в <QueryClientProvider client={queryClient}>
import { queryClient } from '../../../queryClient'

export const useRouteStore = create((set, get) => ({
  // ░░░ UI-ФЛАГИ ░░░
  grouped: false,
  filterStatus: 'Все',
  
  sortOrder: 'sequence', // по умолчанию — сортировка по порядковому номеру// возможные значения: 'sequence','addressAsc','addressDesc','id'
  isSearchVisible: false,
  showFilterMenu: false,
  allExpanded: false,

  // ░░░ МОДАЛЬНОЕ ОКНО КУРЬЕРА ░░░
  modalPage: null,

  // ░░░ ПОИСК И НАВИГАЦИЯ ░░░
  searchQuery: '',
  selectedReceiptId: null,
  selectedReceipt: null,

  // ░░░ ЛОГИ И СТАТУС СКАНЕРА ░░░
  logs: [],
  statusMessage: '',
  isScanning: false,

  // ░░░ ХРАНЕНИЕ ДАННЫХ МАРШРУТА ░░░
  routeData: null,    // объект маршрута с массивом receipts

  // ░░░ ACTIONS / МУТАЦИИ ░░░

  // — UI
  toggleGrouping:    () => set(s => ({ grouped: !s.grouped })),
  setFilterStatus:   status => set({ filterStatus: status }),
   toggleSortOrder:   () => set(s => {
    const nextMap = {
      sequence:   'addressAsc',
      addressAsc: 'addressDesc',
      addressDesc:'id',
      id:         'sequence',
    };
    return { sortOrder: nextMap[s.sortOrder] };
  }),
  toggleSearch:      () => set(s => ({ isSearchVisible: !s.isSearchVisible })),
  toggleFilterMenu:  () => set(s => ({ showFilterMenu: !s.showFilterMenu })),
  toggleExpandAll:   () => set(s => ({ allExpanded: !s.allExpanded })),

  // — Модалка
  setModalPage: pageKey => set({ modalPage: pageKey }),

  // — Поиск
  setSearchQuery: q => set({ searchQuery: q }),

  // — Загрузка маршрута
  setRouteData: data => set({ routeData: data }),

  setIsScanning: active => set({ isScanning: active }),

  // — Выбор квитанции
  setSelectedReceiptId: idRaw => {
    const id = typeof idRaw === 'string' ? parseInt(idRaw, 10) : idRaw
    const route = get().routeData
    const found = route?.receipts.find(r => r.id === id) ?? null
    set({ selectedReceiptId: id, selectedReceipt: found })
  },

  // — Актуализация квитанции в маршруте + пуш в React Query-кэш
updateReceipt: updated => {
  set((state, get) => {
    const receipts = state.routeData.receipts.map(r =>
      r.id === updated.id
        ? { ...r, ...updated }         // ← мёрджим: сохраняем все старые поля + новые из updated
        : r
    );
    const newRoute = { ...state.routeData, receipts };
    const selectedReceipt = newRoute.receipts.find(
      r => r.id === state.selectedReceiptId
    ) || null;

    return {
      routeData: newRoute,
      selectedReceipt
    };
  });

    // Обновление кэша React Query
  const rawId = get().routeData?.id;
  if (rawId != null) {
    const routeId = String(rawId);
    const cacheKey = ['route', routeId];
    queryClient.setQueryData(cacheKey, old => {
      if (!old) return old;
      return {
        ...old,
        receipts: old.receipts.map(r =>
          r.id === updated.id
            ? { ...r, ...updated }     // ← здесь тоже мёрдж
            : r
        )
      };
    });

      // Лог после
      console.log('[React Query] после обновления кэша:', queryClient.getQueryData(cacheKey))
      console.log(`[React Query] обновлена квитанция с id=${updated.id}`)
    }
  },

  // — Логи сканера
  addLog: msg => set(s => ({ logs: [...s.logs, msg] })),
  clearLogs:    () => set({ logs: [] }),
  setStatusMessage: msg => set({ statusMessage: msg }),
  clearStatusMessage: () => set({ statusMessage: '' }),
}))
